<template>
  <!-- 헤더 -->
  <MainHeader :isLoginPage="true" />

  <div class="main-layout">
    <!-- 대시보드 메인 -->
    <div class="dashboard-layout">
      <AppHeader />

      <div class="content-area flex flex-1">
        <div class="flex-1 bg-white p-4">
          <MainTable />
          <BottomBoard />
        </div>

        <div class="w-1/4 bg-white">
          <AppSidebar />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainHeader from "@/components/MainHeader.vue";
import AppHeader from "../components/AppHeader.vue";
import MainTable from "../components/MainTable.vue";
import AppSidebar from "../components/AppSidebar.vue";
import { mapActions, mapMutations } from "vuex";
import { storeName } from "@/global/variable";
import BottomBoard from "@/components/BottomBoard.vue";

// import { authFetch } from "@/plugins/axiosConfig";

let MP_SSE;
let ASSET_SSE;

export default {
  name: "MainDashboard",
  components: {
    MainHeader,
    AppHeader,
    MainTable,
    AppSidebar,
    BottomBoard,
  },

  mounted() {
    // 코인별 현재가 SSE 연결 (server side event) --------------
    MP_SSE = this.$sse.create({
      url: `${process.env.VUE_APP_MARKP_BASE_URL}/sse/emitter`,
      polyfill: true,
      forcePolyfill: true,
      polyfillOptions: {
        headers: {
          Authorization: `Bearer ${this.$store.getters["userStore/ACCESS_TOKEN"]}`,
        },
      },
      withCredentials: true,
    });
    MP_SSE.on("error", (e) => {
      console.log(e);
    });
    MP_SSE.connect().then((sse) => {
      console.log(sse);
    });
    MP_SSE.on("message", this.hanleMessage);
    // 코인별 현재가 SSE 연결 (server side event) -------------- end
    // todo : 해당 페이지 진입시 로직
    // 1. 사용자 현재 자산 조회
    // 2. 사용자 포지션별 자산 조회
    // 3. 사용자 포지션별 거래 매수 설정 데이터 조회
    // 4. 사용자 포지션별 거래 매도 설정 데이터 조회

    ASSET_SSE = this.$sse.create({
      url: `${process.env.VUE_APP_BASE_URL}/sse/emitter`,
      polyfill: true,
      forcePolyfill: true,
      polyfillOptions: {
        headers: {
          Authorization: `Bearer ${this.$store.getters["userStore/ACCESS_TOKEN"]}`,
        },
      },
      withCredentials: true,
    });
    ASSET_SSE.on("error", (e) => {
      console.log("------ error----- ");
      console.log(e);
    });
    ASSET_SSE.on("message", this.handleAssetMessage);
    ASSET_SSE.on("trade", this.handleAssetTrade);
    ASSET_SSE.on("account", this.handleAccountUpdate);
    ASSET_SSE.on("position", this.handlePositionUpdate);
    ASSET_SSE.on("leverage", this.handleLeverageUpdate);
    ASSET_SSE.on("buystop", this.handleBuyStopMsg);
    ASSET_SSE.on("tradeInit", this.handleTradeNew);
    ASSET_SSE.on("tradeHistory", this.handleTradeHistory);

    ASSET_SSE.connect()
      .then(() => {
        console.log("---- sse connect! ----");
      })
      .catch((err) => {
        console.log("---- sse error ---- ", err);
      });

    /*
      초기 페이지 로딩시 조회할 내용
      1. user USDT
      2. all symbol config
      3. all new buy config
      4. btcusdt trade history
      */
    this.$store.dispatch("assetStore/AT_REQ_BALANCE");
    // authFetch.get("/api/asset/config/account");
    this.$store.dispatch("assetStore/AT_UPDATE_SYMBOL_CONFIG");
    // this.$store.dispatch("buyStore/AT_ALL_STEP_LOAD");
    this.$store.dispatch("tradeStore/AT_GET_TRADE_HISTORY", {
      symbol: "BTCUSDT",
      position: "LONG",
    });
    this.$store.dispatch("tradeStore/AT_GET_CUM_LIST");
  },
  unmounted() {
    // 코인별 현재가 SSE 연결 (server side event) --------------
    MP_SSE.disconnect();
    // 코인별 현재가 SSE 연결 (server side event) -------------- end
    ASSET_SSE.disconnect();
  },
  methods: {
    ...mapMutations(storeName.markP, ["MU_UPDATE_MARK_PRICE"]),
    ...mapActions(storeName.asset, [
      "AT_LOAD_SYMBOL_CONFIG",
      "AT_GET_CUM_LIST",
    ]),
    ...mapActions(storeName.buyConfig, ["AC_GET_CONFIG", "AC_GET_ALL_CONFIGS"]),
    ...mapActions(storeName.manual, ["AT_GET_MANUAL"]),
    ...mapActions(storeName.tradeHistory, ["AT_GET_TRADE_HISTORY"]),

    handleGlobalAction(action, data) {
      console.log("Global Action:", action, data);
    },
    handleCoinAction(action, coinId) {
      console.log("Coin Action:", action, coinId);
    },
    hanleMessage(message) {
      // console.log(message);
      this.MU_UPDATE_MARK_PRICE(message);
    },
    // eslint-disable-next-line
    handleAssetMessage(message) {
      // console.log("message", message);
    },
    handleNextTrade(message) {
      const { symbol, position } = message;
      this.AC_GET_CONFIG({ symbol: symbol, position: position });
    },
    handleTradeNew(message) {
      const { symbol, tradeType, position } = message;
      if (tradeType === "b") {
        this.$toast.open({
          message: `${symbol} ${position} 물타기 거래가 요청 되었습니다`,
          type: "success",
        });
        this.AC_GET_CONFIG({
          symbol: symbol,
          position: position.toUpperCase(),
        });
      }
    },
    // 바이낸스 히스토리 업데이트
    async handleTradeHistory(message) {
      const { symbol, position } = message;

      this.AT_GET_TRADE_HISTORY({
        symbol: symbol.toUpperCase(),
        position: position.toUpperCase(),
      });
    },
    /**
     * 바이낸스 거래 주문 상태 변경 메시지 수신
     * @param message
     */
    async handleAssetTrade(message) {
      const { symbol, msg, tradeType } = message;
      let userMsg;
      let _tradeType;
      console.log(symbol, msg, tradeType);
      switch (msg) {
        case "NEW":
          userMsg = "생성";
          break;
        case "FILLED":
          userMsg = "채결";
          break;
        case "CANCELED":
          userMsg = "중지";
          break;
        case "PARTIALLY_FILLED":
          userMsg = "부분 체결";
          break;
        case "FAILED":
          userMsg = "실패";
          break;
      }
      if (tradeType != null) {
        switch (tradeType) {
          case "i":
            _tradeType = "포지션 진입";
            break;
          case "b":
            _tradeType = "물타기";
            break;
          case "t":
            _tradeType = "수익실현";
            break;
          case "f":
            _tradeType = "강제매도";
            break;
          case "mf":
            _tradeType = "수동 매도";
            break;
        }
      }
      if (userMsg != null) {
        if (msg === "FAILED") {
          this.$toast.open({
            message: `${symbol} ${_tradeType} 거래가 실패하였습니다`,
            type: "error",
          });
        } else {
          this.$toast.open({
            message: `${symbol} ${_tradeType} 거래가 ${userMsg} 되었습니다`,
            type: "success",
          });
        }

        if (msg === "FILLED" || msg === "FAILED") {
          switch (tradeType) {
            case "i":
            case "b":
              // 물타기 완전 체결시 && 초기 포지션 진입 완전 체결시
              await this.AC_GET_CONFIG({ symbol: symbol, position: "LONG" });
              await this.AC_GET_CONFIG({ symbol: symbol, position: "SHORT" });
              break;
            case "t":
              // 수익실현 완전 체결시
              await this.AC_GET_CONFIG({ symbol: symbol, position: "LONG" });
              await this.AC_GET_CONFIG({ symbol: symbol, position: "SHORT" });
              break;
            case "f":
              // 강제 매도 완전 체결시
              await this.AC_GET_CONFIG({ symbol: symbol, position: "LONG" });
              await this.AC_GET_CONFIG({ symbol: symbol, position: "SHORT" });
              break;
            case "mf":
              await this.AC_GET_CONFIG({ symbol: symbol, position: "LONG" });
              await this.AC_GET_CONFIG({ symbol: symbol, position: "SHORT" });
              // window.location.reload();
              await this.$store.dispatch("assetStore/AT_UPDATE_BALANCE");
              break;
          }
          await this.AT_GET_MANUAL();
        }

        // TODO : 매수 설정 리스트 업데이트
      }
    },
    /**
     * 자산 변경 메시지 수신 (USDT)
     * @param message
     */
    handleAccountUpdate(message) {
      console.log(message);
      this.$store.dispatch("assetStore/AT_UPDATE_BALANCE");
    },
    /**
     * 포지션 정보 변경 메시지 수진 (symboi)
     * @param message
     */
    handlePositionUpdate(message) {
      console.log("=============position update");
      console.log(message);
      this.$store.dispatch("assetStore/AT_UPDATE_BALANCE");
    },
    /**
     * 레버리지 변경 메시지 수신
     * @param message
     */
    handleLeverageUpdate(message) {
      const { symbol } = message;
      this.$toast.open({
        message: `${symbol} 레버리지가 성공적으로 변경되었습니다.`,
        type: "success",
      });
      this.AT_LOAD_SYMBOL_CONFIG(symbol);
      this.AC_GET_CONFIG({ symbol: symbol, position: "LONG" });
      this.AC_GET_CONFIG({ symbol: symbol, position: "SHORT" });
    },

    /**
     * 사용자 추가 매수 중지 상태 업데이트 메시지 수신
     * @param message
     */
    // eslint-disable-next-line
    handleBuyStopMsg(message) {
      // manual buy stop api 호출 및 mutation 처리
      // console.log(message);
      this.AT_GET_MANUAL();
      this.AC_GET_ALL_CONFIGS();
    },
  },
};
</script>

<style scoped></style>
